var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBhim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256px",
    height: "256px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#efefef",
    d: "M 110.5,2.5 C 165.229,-1.55283 207.062,19.4472 236,65.5C 252.45,96.6841 256.117,129.351 247,163.5C 229.106,214.052 193.606,243.552 140.5,252C 87.2016,255.103 46.3683,234.269 18,189.5C 1.90961,159.411 -2.09039,127.745 6,94.5C 22.6556,43.0018 57.4889,12.3351 110.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f7072",
    d: "M 141.5,109.5 C 143.5,109.5 145.5,109.5 147.5,109.5C 144.977,120.89 142.143,132.223 139,143.5C 136.534,144.777 134.034,144.777 131.5,143.5C 134.855,132.137 138.188,120.804 141.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6f71",
    d: "M 46.5,109.5 C 60.1707,109.333 73.8374,109.5 87.5,110C 87.7551,114.861 86.9218,119.694 85,124.5C 82.5509,125.725 82.0509,127.392 83.5,129.5C 82.7443,134.541 81.0776,139.208 78.5,143.5C 64.8826,144.482 51.2159,144.815 37.5,144.5C 40.656,132.876 43.656,121.209 46.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f7072",
    d: "M 94.5,109.5 C 96.5,109.5 98.5,109.5 100.5,109.5C 99.4972,114.173 98.4972,118.839 97.5,123.5C 106.839,123.666 116.173,123.5 125.5,123C 126.752,118.833 128.085,114.666 129.5,110.5C 131.396,109.534 133.396,109.201 135.5,109.5C 133.145,120.587 130.311,131.587 127,142.5C 125.246,144.25 123.079,144.917 120.5,144.5C 121.185,139.761 122.185,135.094 123.5,130.5C 114.161,130.334 104.827,130.5 95.5,131C 93.4699,135.286 92.1366,139.786 91.5,144.5C 89.5,144.5 87.5,144.5 85.5,144.5C 87.6301,132.585 90.6301,120.918 94.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6f71",
    d: "M 152.5,110.5 C 157.808,118.149 163.141,125.815 168.5,133.5C 177.813,126.022 186.98,118.355 196,110.5C 193.709,121.558 190.875,132.558 187.5,143.5C 185.167,144.833 182.833,144.833 180.5,143.5C 181.833,139.167 183.167,134.833 184.5,130.5C 184.167,130.167 183.833,129.833 183.5,129.5C 178.463,134.539 173.129,139.206 167.5,143.5C 163.5,137.833 159.5,132.167 155.5,126.5C 153.211,132.322 151.544,138.322 150.5,144.5C 148.167,144.5 145.833,144.5 143.5,144.5C 146.188,133.081 149.188,121.747 152.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#228b47",
    d: "M 201.5,137.5 C 204.84,133.828 208.173,130.161 211.5,126.5C 210.157,123.15 208.823,119.817 207.5,116.5C 208.032,114.37 208.865,112.37 210,110.5C 212.579,115.992 215.412,121.325 218.5,126.5C 212.541,131.958 206.708,137.624 201,143.5C 200.82,141.512 200.986,139.512 201.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f27b27",
    d: "M 207.5,116.5 C 208.823,119.817 210.157,123.15 211.5,126.5C 208.173,130.161 204.84,133.828 201.5,137.5C 199.37,139.127 197.37,140.96 195.5,143C 194.833,143.667 194.167,143.667 193.5,143C 196.446,132.052 199.779,121.219 203.5,110.5C 204.857,112.565 206.19,114.565 207.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4f4",
    d: "M 51.5,116.5 C 60.8333,116.5 70.1667,116.5 79.5,116.5C 79.8957,119.044 79.229,121.211 77.5,123C 68.5062,123.5 59.5062,123.666 50.5,123.5C 50.6741,121.139 51.0074,118.806 51.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f5f5",
    d: "M 47.5,130.5 C 56.5062,130.334 65.5062,130.5 74.5,131C 75.9348,133.267 75.6015,135.267 73.5,137C 64.5062,137.5 55.5062,137.666 46.5,137.5C 46.6741,135.139 47.0074,132.806 47.5,130.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhim);
export default __webpack_public_path__ + "static/media/BHIM.2b8a458f0e3f3b07c79285a56058b7e2.svg";
export { ForwardRef as ReactComponent };